import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'src/presentation/components/agent_desktop_components';
import Form, { useForm, FormEditorProps } from 'src/presentation/components/forms/Form';
import Footer from 'src/presentation/components/forms/Footer';
import idleTimingResource from 'src/actions/idleTiming/idleTimingResource';
import Input, { InputType } from 'src/presentation/components/forms/Input';
import { Body, Row, Section } from 'src/presentation/components/forms/Layout';

const IdleTimingForm: FC<FormEditorProps> = ({ item, errors }) => {
  const formContext = useForm({
    item,
    errors,
    resetErrors: idleTimingResource.actions.resetErrors,
    root: 'idle-timing',
    update: idleTimingResource.effects.replace,
    validate: idleTimingResource.effects.validate,
  });
  const { onSave, workingState } = formContext;
  const hasChanged =
    item.autoAwayMinutes !== workingState.autoAwayMinutes ||
    item.autoOfflineMinutes !== workingState.autoOfflineMinutes;
  return (
    <Form context={formContext}>
      <Body data-aid={'editor'}>
        <Section>
          <Row>
            <MinutesInput
              data-aid={'editor-autoAwayMinutes-input'}
              attr="autoAwayMinutes"
              autoFocus
              label="Time Until Away"
              description="Time in minutes when an agent will be automatically marked away"
              placeholder="in minutes"
              type={InputType.number}
            />
          </Row>
          <Row>
            <MinutesInput
              data-aid={'editor-autoOfflineMinutes-input'}
              attr="autoOfflineMinutes"
              label="Time Until Logged Off"
              description="Time in minutes when an agent will be automatically logged off"
              placeholder="in minutes"
              type={InputType.number}
            />
          </Row>
        </Section>
      </Body>

      <Footer>
        <Button data-aid={'editor-save'} onClick={onSave} disabled={!hasChanged}>
          Save
        </Button>
      </Footer>
    </Form>
  );
};
export default IdleTimingForm;

const MinutesInput = styled(Input)`
  max-width: 100px;
`;
